<template>
  <div class="select-style-box">
    <v-iselect
      v-if="theme == 'vogue'"
      type="detail"
      :theme="theme"
      :item="attrs"
      :value="variant_attrs[index].value"
      :index="index"
    ></v-iselect>
    <div
      v-else
      class="default-select"
      :class="{ 'default-select-dropdown': show_dropdown }"
    >
      <select
        class="secondary_title"
        v-model="variant_attrs[index].value"
        :name="key_name+variant_attrs[index].name"
      >
        <option v-for="(subitem, index) in attrs.value" :key="`${subitem}_${index}`" :value="subitem">
          {{ subitem }}
        </option>
      </select>
    </div>
  </div>
</template>
<script>
import vIselect from "../../../../../js/components/view/productpalette/iselect";
export default {
  props: {
    variant_attrs: {},
    index: {},
    attrs: {},
    theme: {},
    show_dropdown: {},
    key_name:{},
  },
  data() {
    return {};
  },
  components: {
    vIselect,
  },
};
</script>
<style scoped lang='scss'>
.select-style-box {
  .default-select {
    select {
      position: relative;
      list-style: none;
      direction: ltr;
      box-sizing: inherit;
      font-size: 100%;
      margin: 0;
      text-transform: none;
      display: block;
      border-radius: 0;
      height: 48px;
      line-height: 22px;
      padding: 12px;
      color: #1e0909;
      border: 1px solid #e4e4e4;
      width: 100%;
      margin-bottom: 12px;
      cursor: pointer;
      font-weight: 400;
      background: rgba(255, 255, 255, 0.8);
      padding-left: 5px !important;
      font-family: "Roboto", sans-serif;
      border-color: rgba(17, 17, 17, 0.2);
      appearance: none;
      padding-right: 30px;
      transition: 0s;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .default-select-dropdown {
    position: relative;
    &::after {
      content: "\e62a";
      font-family: "iconfont";
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 12px;
      font-size: 15px;
      color: rgba(17, 17, 17, 0.4);
      pointer-events: none;
    }
  }
}
</style>